// This file is generated.
export var version = '1.78.1';
//# sourceMappingURL=version.js.map